import request from '@/utils/request'

// 采集器管理列表页查询
export function collectorManagePageQuery(data){
  return request({
    url:'/db/collector/manage-page-query',
    method:'post',
    data
  })
}

//采集器状态数量总览
export function statusInfoQuery(data){
  return request({
    url:'/db/collector/status-info-query',
    method:'post',
    data
  })
}


//采集器上线下线接口调用
export function stateUpdate(data){
  return request({
    url:'/db/collector/state-update',
    method:'put',
    data
  })
}

// 采集器解绑
export function unbind(data){
    return request({
        url:'/db/collector/unbind',
        method:'put',
        data
    })
}

// 采集器删除
export function deleteCollector(data){
    return request({
        url:'/db/collector/delete',
        method:'post',
        data
    })
}

// 采集器所属传感器查询
export function collectorSensorQuery(data){
  return request({
    url:'/db/sensor/collector-sensor-query',
    method:'post',
    data
  })
}


// 传感器参数配置修改
export function configUpdate(data){
  return request({
    url:'/db/sensor/config-update',
    method:'put',
    data
  })
}


// 传感器预警配置查询
export function warningConfigQuery(data){
  return request({
    url:'/db/sensor/warning-config-query',
    method:'post',
    data
  })
}


//通过phone获取外部系统用户信息
export function notifierQuery(data){
  return request({
    url:'/db/sensor/notifier-query',
    method:'post',
    data
  })
}

//传感器预警配置修改
export function warningConfigUpdate(data){
  return request({
    url:'/db/sensor/warning-config-update',
    method:'put',
    data
  })
}

//采集器详情查询
export function collectorDetailQuery(data){
  return request({
    url:'/db/collector/detail-query',
    method:'post',
    data
  })
}

// 文件上传
export function collectorImport(data){
  return request({
    url:'/db/collector/collector-import',
    method:'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}


// 实时预警报表下载
export function currentWarningReportDownload(data) {
  return request({
    url: '/db/warn-detail/current-warning-report-download',
    method: 'post',
    data
  })
}

// 离线预警配置修改
export function offLineConfigUpdate(data) {
  return request({
    url: '/db/off-line-config/update',
    method: 'post',
    data
  })
}

// 离线预警配置查询
export function offLineConfigQuery(data) {
  return request({
    url: '/db/off-line-config/query',
    method: 'post',
    data
  })
}

// 节点最后一次上传数据报表下载
export function lastDataDownload(data) {
  return request({
    url: '/db/collector/last-data-download',
    method: 'post',
    data
  })
}